import { render, staticRenderFns } from "./ManualAddOnItems.vue?vue&type=template&id=069c0aa4&scoped=true&"
import script from "./ManualAddOnItems.vue?vue&type=script&lang=js&"
export * from "./ManualAddOnItems.vue?vue&type=script&lang=js&"
import style0 from "./ManualAddOnItems.vue?vue&type=style&index=0&id=069c0aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069c0aa4",
  null
  
)

export default component.exports